var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutterpng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7852 133.941L97.3086 156.641L159.277 94.1875H114.219L74.7852 133.941Z",
    fill: "#5CC8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.219 26.0508H159.277L63.5195 122.586L40.9805 99.8789L114.219 26.0508Z",
    fill: "#5CC8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3086 156.641L114.219 173.668H159.277L119.844 133.941L97.3086 156.641Z",
    fill: "#075B9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.73 144.984L119.844 133.941L97.3086 156.641L130.73 144.984Z",
    fill: "url(#paint0_linear_44_10)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7852 133.934L97.3203 111.207L119.859 133.922L97.3203 156.641L74.7852 133.934Z",
    fill: "#16B9FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_10",
    x1: 97.2656,
    y1: 156.641,
    x2: 125.391,
    y2: 139.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124793",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterpng);
export default __webpack_public_path__ + "static/media/Flutter.png.2211ad55d1aab4a2ad437a2f40590391.svg";
export { ForwardRef as ReactComponent };